<template>
  <div class="level first-level">
    <div class="level-left">
      <div class="level-item" v-if="canCreate">
        <router-link :to="formLink">
          <b-button
            type="is-primary"
            icon-right="plus"
            :disabled="disabled"
          ></b-button>
        </router-link>
      </div>
      <!--<div class="level-item" v-if="canDelete">
        <b-button
          size="is-small"
          type="is-primary"
          icon-right="delete"
          :disabled="disabled || checkedRows.length == 0"
          @click="deleteItems()"
        ></b-button>
      </div>-->
      <div class="level-item" v-if="canExport">
        <b-button
          type="is-primary"
          icon-right="table-large"
          :disabled="disabled || checkedRows.length == 0"
          @click="getTable"
        ></b-button>
      </div>

      <div class="level-item">
        <!-- v-if="canHide">-->
        <b-dropdown aria-role="list">
          <b-button
            type="is-primary"
            class="button is-primary"
            :disabled="disabled"
            slot="trigger"
            icon-right="delete-outline"
          />
            <!--icon-right="delete"-->
          <b-dropdown-item
            v-if="canDelete"
            class="pointercursor linktype"
            :disabled="disabled || checkedRows.length == 0"
            @click="deleteItems()"
            >{{ $translate("delete") | capitalize }}</b-dropdown-item
          >
          <b-dropdown-item
            v-if="canHide"
            class="pointercursor linktype"
            :disabled="disabled || checkedRows.length == 0"
            @click="hideItems()"
            >{{ $translate("hide") | capitalize }}</b-dropdown-item
          >
          <b-dropdown-item
            class="pointercursor linktype"
            @click="
              viewHidden = !viewHidden;
              manageHiddenInput();
            "
            >{{
              viewHidden
                ? $translate("hide_hide")
                : $translate("view_hide") | capitalize
            }}</b-dropdown-item
          >
        </b-dropdown>
        <!--<b-button
          size="is-small"
          type="is-primary"
          :icon-right="multipleSelectionIcon"
          :disabled="disabled || checkedRows.length == 0"
          @click="hideItems()"
        ></b-button>-->
      </div>
      <!--<div class="level-item">
        <div class="field">
          <b-switch
            v-model="viewHidden"
            @input="manageHiddenInput"
            :disabled="disabled"
          >{{ $translate("view_hide") | capitalize }}</b-switch>
        </div>
      </div>-->
    </div>
    <div class="level-right">
      <b-input
        :disabled="disabled"
        :placeholder="$translate('search').concat('...') | capitalize"
        v-model="queryString"
        type="search"
        icon="magnify"
        @keyup.native.enter="searchData"
        @input="changesearchQuery"
      ></b-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "tableActions",
  props: {
    disabled: Boolean,
    canCreate: Boolean,
    canDelete: Boolean,
    canExport: { type: Boolean, default: false },
    canHide: Boolean,
    multipleSelectionIcon: String,
    formLink: Object,
    checkedRows: Array
  },
  data() {
    return {
      queryString: "",
      viewHidden: false
    };
  },
  methods: {
    manageHiddenInput() {
      this.checkedRows = [];
      this.$emit("update:checkedRows", []);
      this.$emit("viewhiddenchange", this.viewHidden);
    },
    searchData() {
      this.$emit("search", this.queryString);
    },
    changesearchQuery() {
      this.$emit("changesearchQuery", this.queryString);
    },
    getTable() {
      this.$emit("getTable", this.queryString);
    },
    hideItems() {
      this.$emit("hideItems");
    },
    deleteItems() {
      this.$emit("deleteItems");
    }
  }
};
</script>
